import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";

function SvgComponent(props) {
  return (
    <Svg
      width={40}
      height={40}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <Circle cx={20} cy={20} r={20} fill="#000" fillOpacity={0.02} />
      <Path
        d="M18.76 23.571c.195-.032.389-.056.58-.099 1.942-.44 3.282-1.63 3.943-3.573 1.026-3.012-.79-6.334-3.793-7.01a5.266 5.266 0 00-1.176-.128h-5.622l-.02-.032c.034-.028.071-.053.105-.085.4-.415.801-.83 1.2-1.248a.797.797 0 00.201-.826.76.76 0 00-.607-.556c-.279-.053-.518.046-.715.255l-2.27 2.382c-.12.124-.242.248-.358.376a.806.806 0 00-.003 1.12c.882.925 1.768 1.846 2.658 2.764a.75.75 0 001.1.004.826.826 0 000-1.152c-.395-.422-.797-.833-1.199-1.248-.034-.035-.075-.056-.099-.078.017-.053.034-.05.051-.05 1.412.004 4.33-.017 5.741.011 1.773.04 3.225 1.4 3.497 3.222.293 1.964-1.022 3.895-2.9 4.26a4.06 4.06 0 01-.774.075h-7.448c-.426 0-.736.252-.815.649a.8.8 0 00.545.939c.024.007.055-.007.065.028h8.113z"
        fill="#141414"
      />
      <Path
        d="M18.143 27.356v-.545c.028-.443.267-.792.469-1.157.638-1.152 1.28-2.303 1.922-3.454.531-.953 1.06-1.905 1.591-2.854.17-.307.34-.613.513-.92.315-.548.78-.88 1.39-.95.708-.074 1.297.187 1.712.794.327.482.582 1.01.865 1.52.871 1.558 1.74 3.12 2.608 4.683.27.49.534.985.817 1.464.268.45.378.93.306 1.452-.05.365-.202.685-.438.956a1.831 1.831 0 01-1.447.655c-2.83-.003-5.662 0-8.493 0-.774 0-1.466-.506-1.73-1.256-.044-.13-.054-.26-.085-.388z"
        fill="#FF2E00"
        stroke="#fff"
        strokeWidth={1.5}
      />
      <Path
        d="M24.379 24.981c-.269 0-.486-.174-.512-.443-.032-.31-.045-.627-.06-.938-.046-.75-.095-1.498-.133-2.248-.017-.31.09-.57.368-.734a.69.69 0 011.032.53c.03.324-.02.644-.035.964-.04.77-.104 1.54-.123 2.31-.017.333-.23.56-.537.56zM25.063 26.188a.69.69 0 01-.692.676.704.704 0 01-.689-.7.707.707 0 01.709-.695c.381.004.676.317.672.719z"
        fill="#fff"
      />
    </Svg>
  );
}

export default SvgComponent;
